/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { VariantAssignmentConfig, VariantAssignmentResponseSwaggers } from 'src/core/services/azureExpSwaggers';
import { AzureExpFeatureFlag, AzureExpFeatureValue, AzureExpStore } from 'src/core/stores/AzureExpStore';

export const azureExpSwaggersToAzureExpStore = (swagger: VariantAssignmentResponseSwaggers) => {
    const featureFlags: AzureExpFeatureFlag[] = [];
    swagger.Configs.forEach((c: VariantAssignmentConfig) => {
        Object.entries(c.Parameters).map(([featureName, featureValue]) => {
            featureFlags.push({
                namespace: c.Id,
                name: featureName,
                value: featureValue as AzureExpFeatureValue
            });
        });
    });
    return new AzureExpStore(swagger.ImpressionId, swagger.AssignmentContext, featureFlags);
};
